// src/blocks/image/image.tsx
import NextImage from "next/image";
import { jsx, jsxs } from "react/jsx-runtime";
var Image = ({
  className,
  imageClassName,
  id,
  alt,
  caption,
  aspectRatio,
  style,
  src,
  ...rest
}) => {
  if (!src) return null;
  return /* @__PURE__ */ jsxs("div", { className, id, style, children: [
    /* @__PURE__ */ jsx("picture", { children: /* @__PURE__ */ jsx(
      NextImage,
      {
        src,
        role: alt ? void 0 : "presentation",
        className: imageClassName,
        alt: alt || "",
        placeholder: rest.blurDataURL,
        style: {
          aspectRatio
        },
        ...rest
      }
    ) }),
    caption && /* @__PURE__ */ jsx("figcaption", { children: caption })
  ] });
};
var image_default = Image;

export {
  image_default
};
